import React from "react";
import { useCurrency } from "@/context/CurrencyContext";

const OPTIONS = ["INR", "AED", "EUR"];

export default function CurrencySwitcher() {
  const { currency, setCurrency } = useCurrency();
  return (
    <div data-testid="currency-switcher" className="hidden sm:flex items-center border border-[color:var(--line)] font-mono text-[11px]">
      {OPTIONS.map((c) => (
        <button
          key={c}
          data-testid={`currency-${c}`}
          onClick={() => setCurrency(c)}
          className={`px-2.5 py-1.5 tracking-widest transition-colors duration-200 ${
            currency === c ? "bg-[color:var(--brand)] text-white" : "text-neutral-700 hover:bg-neutral-100"
          }`}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
